import { Box } from '@mui/material';
import type { FC } from 'react';

import type { QuotePdfModalContentProps } from '../../pages/Quotes/QuoteDetails/QuotePdfModal';
import { QuotePdfModalContent } from '../../pages/Quotes/QuoteDetails/QuotePdfModal';
import { Input } from '../Input/Input';

export type NylasStepSetUpTemplateProps = QuotePdfModalContentProps;

export const NylasStepSetUpTemplate: FC<NylasStepSetUpTemplateProps> = ({
  quote,
  onPdfChanged,
  requiresQuoteApprovals,
}) => {
  return (
    <Box mt='1.25rem' gap='1.25rem' display='flex' flexDirection='column'>
      <Input label='Filename*' name='file.fileName' />
      <QuotePdfModalContent
        quote={quote}
        onPdfChanged={onPdfChanged}
        requiresQuoteApprovals={requiresQuoteApprovals}
      />
    </Box>
  );
};
